import { Component, EventListener } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import {
	getLocalStorageItem,
	deleteLocalStorageItem,
	localStorageValueExists,
	setLocalStorageItem,
} from '@swisslife/shared-ui/src/utils/local-storage/js/local-storage';

enum States {
	IsVisible = 'state-m-cookie-disclaimer--is-visible',
	IsTransitioning = 'state-m-cookie-disclaimer--is-transitioning',
}

enum Selectors {
	DismissButton = '.js-m-cookie-disclaimer__dismiss',
}

interface ICookieDisclaimerConfiguration {
	localStorageId: string;
	localStorageName: string;
}

@Component('CookieDisclaimer')
export class CookieDisclaimer extends GondelJqueryComponent {
	private configuration: ICookieDisclaimerConfiguration;
	private currentStorageId: [any];

	public start() {
		this.configuration = {
			localStorageId: this.$ctx.data('local-storage-id').toString(),
			localStorageName: this.$ctx.data('local-storage-name'),
		};
		this.currentStorageId = getLocalStorageItem(this.configuration.localStorageName);
		this.checkDisclaimerVisibility();
	}

	@EventListener('click', Selectors.DismissButton)
	private _handleCookieClick() {
		if (this.hasStorageIdChanged()) {
			const currentStorageId = getLocalStorageItem(this.configuration.localStorageName);
			deleteLocalStorageItem(this.configuration.localStorageName, currentStorageId.toString());
		}
		setLocalStorageItem(this.configuration.localStorageName, this.configuration.localStorageId);
		this.checkDisclaimerVisibility();
	}

	private hasStorageIdChanged(): boolean {
		return this.currentStorageId && this.currentStorageId.toString() !== this.configuration.localStorageId;
	}

	private checkDisclaimerVisibility() {
		const valueExists = localStorageValueExists(
			this.configuration.localStorageName,
			this.configuration.localStorageId
		);
		if (valueExists) {
			this.$ctx.removeClass(States.IsTransitioning);
			this.$ctx.outerWidth(); // Reflow to make transition work
			this.$ctx.removeClass(States.IsVisible);
		} else {
			this.$ctx.addClass(States.IsVisible);
			this.$ctx.outerWidth(); // Reflow to make transition work
			this.$ctx.addClass(States.IsTransitioning);
		}
	}
}
